// The "Saved needs" dropdown in the Search header: one row per saved need (name, criteria and saved
// counts, a dot when there is new activity). Choosing a row loads its criteria; Rename / Delete sit on
// the row and show on hover or keyboard focus.
import React, { useEffect, useRef, useState } from 'react';

const criteriaCount = (s) => [
  (s.sport_slugs || []).length, (s.positions || []).length, (s.class_years || []).length,
  (s.states || []).length, Object.keys(s.minimums || {}).length, s.verified_only,
].filter(Boolean).length;

export default function SavedNeedsMenu({ needs, onApply, onRename, onDelete }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', away);
    return () => document.removeEventListener('mousedown', away);
  }, [open]);

  return (
    <div className="srch-needs" ref={ref}>
      <button type="button" className="adm-btn" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        Saved needs ▾
      </button>
      {open && (
        <div className="srch-menu srch-menu--needs" role="menu">
          {needs.length === 0 && <div className="srch-menu__note">No needs yet. Set some filters and choose Save as need.</div>}
          {needs.map((s) => (
            <div key={s.id} className="srch-need">
              <button type="button" role="menuitem" className="srch-need__main"
                onClick={() => { setOpen(false); onApply(s); }}>
                <span className="srch-need__name">
                  {s.name}
                  {s.has_new_activity && <span className="srch-need__dot" role="img" aria-label="New activity" />}
                </span>
                <span className="srch-need__sub">{criteriaCount(s)} criteria · {s.board_count ?? 0} saved</span>
              </button>
              <span className="srch-need__tools">
                <button type="button" className="srch-link" aria-label={`Rename ${s.name}`} onClick={() => onRename(s)}>Rename</button>
                <button type="button" className="srch-link srch-link--danger" aria-label={`Delete ${s.name}`} onClick={() => onDelete(s)}>Delete</button>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
